import {
    Component,
    EventEmitter,
    Input,
    OnChanges, OnDestroy,
    OnInit,
    Output,
    SimpleChanges,
    TemplateRef,
    ViewChild,
    ChangeDetectorRef,
    inject
} from '@angular/core';
import { DataAction, DataRowAction, DataRowColumn } from '../../models/datarow';
import { ColumnMode } from '@swimlane/ngx-datatable';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

import { CommonModule } from '@angular/common';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { TranslateModule } from '@ngx-translate/core';
import { MomentModule } from 'ngx-moment';
import { ClipboardModule } from 'ngx-clipboard';
import { AccessControlDirective } from '../../directives/access-control/access-control.directive';

@Component({
    selector: 'app-data-list',
    templateUrl: './data-list.component.html',
    styleUrls: ['./data-list.component.scss'],
    standalone: true,
    imports: [CommonModule, NgxDatatableModule, TranslateModule, MomentModule, ClipboardModule, AccessControlDirective]
})
export class DataListComponent implements OnInit, OnChanges, OnDestroy {
    protected readonly translate = inject(TranslateService);
    @Input() data!: any[];
    @Input() columns: DataRowColumn[] = [];
    @Input() actions: DataRowAction[] = [];
    @Input() rowLimit = 10;
    @Input() entityTitle = 'datatables.default_label';
    @Input() isLoading = false;
    @Input() detailTemplate?: TemplateRef<any>;
    @Input() noResultsMessage = 'datatables.no_result';
    @Output() action: EventEmitter<DataAction> = new EventEmitter<DataAction>();
    @ViewChild('dataTable', { static: true }) table: any;

    readonly language: string;
    readonly columnMode = ColumnMode;
    messages = { emptyMessage: '', totalMessage: '' };
    expanded: any = {};
    isExpandable = false;
    selected = [];
    showMasked!: number | null;
    subscription: Subscription = new Subscription();
    private activeRow!: unknown;

    private cdr: ChangeDetectorRef = inject(ChangeDetectorRef)

    constructor(
    ) {
        this.language = this.translate.currentLang;

        this.subscription.add(this.translate.onLangChange.subscribe(() => this.setMessage()));
    }

    ngOnInit() {
        this.setMessage();
    }

    ngOnDestroy() {
        this.subscription.unsubscribe();
    }

    ngOnChanges(changes: SimpleChanges) {
        if (changes['entityTitle'] || changes['data']) {
            this.setMessage();

            this.cdr.detectChanges();

            if (this.table) {
                this.table.recalculate();
            }
        }
    }

    getRowClass = (row: any) => {
        return {
            'active': row['active']
        };
    }

    toggleExpandRow(row: any) {
        console.log('row', row);
        if (this.activeRow && this.activeRow !== row) {
            (this.activeRow as any).active = false;
            this.table.rowDetail.collapseAllRows();
        }
        this.activeRow = row;
        this.table.rowDetail.toggleExpandRow(row);
        row.active = !row.active;
        
        // Force ngx-datatable to re-evaluate row classes by changing the function reference
        this.getRowClass = (row: any) => {
            return {
                'active': row['active']
            };
        };
    }

    emitAction(event: Event, type: string, data: any) {
        event.preventDefault();
        event.stopPropagation();

        this.action.emit({ type: type, data: data });
    }

    toggleMasked(rowIndex: number) {
        this.showMasked = this.showMasked !== rowIndex ? rowIndex : null;
    }

    setMessage() {
        this.messages.emptyMessage = `<span class="text-bold">${this.translate.instant(this.noResultsMessage)}</span><br>`;
        if (this.entityTitle) {
            this.messages.totalMessage = this.translate.instant(this.entityTitle);
        }
    }
}
